interface SftpBadgeStyles {
  bgColor: string;
  textColor: string;
  title: string;
}

export const getSftpBadgeStyles = (
  sftpStatus: string | null | undefined,
): SftpBadgeStyles => {
  if (!sftpStatus) {
    return {
      bgColor: "#111111",
      textColor: "#FFFFFF",
      title: "Not Sent",
    };
  }

  const normalizedStatus = sftpStatus.toLowerCase();

  if (normalizedStatus === "success") {
    return {
      bgColor: "#E6F3F0",
      textColor: "#005D49",
      title: "Success",
    };
  }

  if (normalizedStatus === "error") {
    return {
      bgColor: "#FFE8E8",
      textColor: "#CC0300",
      title: "Error",
    };
  }

  if (normalizedStatus === "resubmit") {
    return {
      bgColor: "#FFF3E6",
      textColor: "#C24400",
      title: "Resubmit",
    };
  }

  // Default case for any other status
  return {
    bgColor: "#111111",
    textColor: "#FFFFFF",
    title: "Not Sent",
  };
};

export const shouldDisableSftpButton = (
  sftpStatus: string | null | undefined,
): boolean => {
  return !sftpStatus || sftpStatus === "null";
};
